/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimePayrunArchiveCtrl
 */
angular.module('mercury.modules.time.payroll.payrun')
.controller('TimePayrollPayrunArchiveCtrl', ["reporttime", "$scope", "TimePayrollPayruns", "title", function(reporttime, $scope, TimePayrollPayruns, title) {
  title.set('Completed Payruns');
  reporttime.defaultType = 'month';

  $scope.loading = TimePayrollPayruns.getArchive(reporttime.start(), reporttime.end());
  $scope.loading.then(function(result) {
    $scope.payruns = result;
  });
}]);
